/**
 * The borrower profile's tabs, as data.
 *
 * Its own module because three unrelated things need to agree on these ids:
 * the profile page that renders them, the `mira:` link resolver that turns a
 * section name into a step, and the /fees-worksheet route that redirects into
 * one. Importing the page itself to reach a number would pull the whole
 * profile into a chat bundle and a redirect, so the numbers live here and the
 * page imports them like everyone else.
 */

/**
 * The worksheet is a tab in this list but not a step of the application: the
 * borrower fills in 1-8 and only reads 9. Everything keyed off "how far
 * through the form are they" — the completion ticks, the stored timeline, the
 * maxStage gate — has to skip it, or opening the tab reads as progress.
 */
export const FEES_STEP_ID = 9;

export const B2C_STEPS = [
  { id: 1, name: 'Personal Details' },
  { id: 2, name: 'Loan Info' },
  { id: 3, name: 'Income' },
  { id: 4, name: 'Assets' },
  { id: 5, name: 'Liabilities' },
  { id: 6, name: 'REO' },
  { id: 7, name: 'Declaration' },
  { id: 8, name: 'Demographics' },
  { id: FEES_STEP_ID, name: 'Fees Worksheet' },
];

/** The steps that make up the application itself, which is what the stored
 *  timeline and the completion ticks describe. */
export const B2C_FORM_STEPS = B2C_STEPS.filter((step) => step.id !== FEES_STEP_ID);

/**
 * Section name → step id.
 *
 * The name is the stable thing: it is what a `mira:` link and a share link
 * carry, both of which outlive any particular ordering of these tabs. Only
 * this table knows the numbers.
 */
export const B2C_PROFILE_STEP_KEYS = {
  'personal-details': 1,
  'loan-info': 2,
  income: 3,
  assets: 4,
  liabilities: 5,
  reo: 6,
  declaration: 7,
  demographics: 8,
  'fees-worksheet': FEES_STEP_ID,
  fees: FEES_STEP_ID,
};
